"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function hasDiff(prevProps, props) {
  var pkeys = Object.keys(prevProps);
  var nkeys = Object.keys(props);

  if (pkeys.length !== nkeys.length) return true;

  return !!Array.prototype.find.call(nkeys, function (key) {
    return prevProps[key] !== props[key];
  });
}

exports.default = hasDiff;